import React from 'react';
import PropTypes from 'prop-types';
import PlanUserAvatars from 'components/coaching/PlanUserAvatars';
import ReviewTime from 'components/coaching/ReviewTime';
import ReviewLocation from 'components/coaching/ReviewLocation';
import CoachingPlan from 'records/CoachingPlan';
import CoachingReview from 'records/CoachingReview';
import {Map} from 'immutable';
import User from 'records/User';
import './CoachingReviewInfoBar.styl';

export default class CoachingReviewInfoBar extends React.PureComponent {
  render() {
    const {plan, review, users, sessionUser, inProgress, toggleModify, isRecipient} = this.props;
    const rep = plan.recipient.info;
    const coach = users.get(review.coachUserId);

    const otherUserId = [plan.recipient.info.id, review.coachUserId].find(
      id => id !== sessionUser.id
    );
    const otherUser = users.get(otherUserId);

    return (
      <header className="coaching-review-info-bar">
        <div className="participants">
          <PlanUserAvatars coach={coach} recipient={rep} />
          <h3>
            Meeting with {otherUser && otherUser.getFullName()}
            {inProgress && ' - In Progress'}
          </h3>
        </div>
        {!inProgress && (
          <div className="time">
            <ReviewTime
              plan={plan}
              review={review}
              toggleModify={toggleModify}
              isRecipient={isRecipient}
            />
          </div>
        )}
        {!plan.adHoc && !inProgress && <ReviewLocation review={review} />}
      </header>
    );
  }
}

CoachingReviewInfoBar.propTypes = {
  plan: PropTypes.instanceOf(CoachingPlan),
  review: PropTypes.instanceOf(CoachingReview),
  users: PropTypes.instanceOf(Map), // Map<UserId, User>
  sessionUser: PropTypes.instanceOf(User),
  inProgress: PropTypes.bool,
};
